var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lesson_description_container"},[_vm._t("default"),_c('v-md-editor',{staticClass:"lesson_description",class:{ 'spacement': _vm.fromPlayer },attrs:{"value":_vm.getCurrentLesson.content,"mode":"preview"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }